import type { QuestionGroupTemplateContract } from '@/contracts/question-groups'
import { createSyntheticMeta } from '@/contracts/questionnaire'
import { miaolinQuestionGroupDefinitions, mockWorkspaceId, sampleQuestions } from '@/lib/mock-data'
import type { Choice, Question } from '@/types/form'

function templateQuestionId(questionId: string) {
  return questionId.replace('q-miaolin-', 'qgt-miaolin-')
}

function cloneQuestionForTemplate(question: Question, templateId: string, orderIndex: number) {
  const nextQuestionId = templateQuestionId(question.id)
  return {
    ...structuredClone(question),
    id: nextQuestionId,
    formId: templateId,
    groupId: templateId,
    orderIndex,
    choices: question.choices.map(
      (choice, choiceIndex): Choice => ({
        ...choice,
        id: `${nextQuestionId}-choice-${choiceIndex + 1}`,
        questionId: nextQuestionId,
        orderIndex: choiceIndex,
      }),
    ),
  }
}

export function createDefaultQuestionGroupTemplates(): QuestionGroupTemplateContract[] {
  return miaolinQuestionGroupDefinitions.map((definition) => {
    const questions = sampleQuestions
      .filter((question) => question.groupId === definition.id)
      .map((question, orderIndex) => cloneQuestionForTemplate(question, definition.id, orderIndex))

    return {
      id: definition.id,
      workspaceId: mockWorkspaceId,
      title: definition.title,
      description: definition.description,
      category: definition.category,
      tags: [...definition.tags],
      questionIds: questions.map((item) => item.id),
      questions,
      logicJumps: [],
      usageCount: 0,
      updatedAt: '2026-05-26T00:00:00.000Z',
      sourceMeta: createSyntheticMeta('2026-05-26'),
    }
  })
}
